// extracted by mini-css-extract-plugin
module.exports = {"active":"OrderStatusTag_active__ZJAS_","reject":"OrderStatusTag_reject__1u7mK"};